module.exports = __webpack_public_path__ + "img/32.8966a90f.jpg";